<template lang="pug">
  v-container.pa-0.black(fluid style="overflow: hidden;")
    v-row(style="height: 100vh;" align="center" justify="center")
      v-col(align="center")
        the-ato-snackbar
        slot
</template>

<script>
import TheAtoSnackbar from '@/components/tools/TheAtoSnackbar'
export default {
  components: {
    TheAtoSnackbar
  }
}
</script>